<template>
  <div class="container">
    <div class="table-container">
      <div class="container-head">
        <el-button type="primary" @click="dialogFormVisible = true">创建模板</el-button>
      </div>
      <el-table :data="tableData" stripe border="" height="500" style="width: 100%">
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
        <el-table-column prop="tmpl_id" label="模板ID"></el-table-column>
        <el-table-column prop="params" label="模板参数"></el-table-column>
        <el-table-column prop="type" label="模板类型"></el-table-column>
        <el-table-column prop="status_zn" label="状态"></el-table-column>
        <el-table-column prop="priority" label="优先级"></el-table-column>
        <el-table-column prop="time" label="创建时间"></el-table-column>
        <el-table-column prop="done_time" label="完成时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 0">
              <el-button type="primary" @click="handler(scope.row)">发送</el-button>
              <el-button @click="handler(scope.row)" type="primary">暂停</el-button>
              <el-button @click="handler(scope.row)" type="primary">取消</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="创建模板" :visible.sync="dialogFormVisible">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="模板ID" prop="tmpl_id">
            <el-input v-model="form.tmpl_id" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="优先级">
            <el-input-number v-model="form.priority" :min="1" label="描述文字"></el-input-number>
          </el-form-item>
          <el-form-item label="模板类型">
            <el-select v-model="form.allow_endpoints" placeholder="请选择模板类型">
              <el-option label="模板消息" value="wt"></el-option>
              <el-option label="客服消息" value="wc"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模板参数">
            <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="form.param"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="form.description"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="createTemplate">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import request from '../../api/request'
// import { format } from 'date-fns'
export default {
    data() {
        const checkDescription = (rule, value, callback) => {
            if (!value) {
                callback(new Error('描述不能为空'))
            } else if (value.length < 9) {
                callback(new Error('描述不能长度不能小于9'))
            } else {
                callback()
            }
        }
        return {
            tableData: [],
            dialogFormVisible: false,
            form: {
                tmpl_id: '',
                param: '',
                description: '',
                allow_endpoints: 'wt',
                priority: '',
            },
            rules: {
                tmpl_id: [{ required: true, message: '请输入正确的信息', trigger: 'blur' }],
                description: [
                    {
                        required: true,
                        validator: checkDescription,
                        trigger: 'blur',
                    },
                ],
            },
        }
    },
    created() {
        this.getItemList()
    },
    methods: {
        async getItemList() {
            const params = {
                range: [0, 1e6],
            }
            const resp = await request.messenger.post('broadcast_list', params)
            this.tableData = resp.data.list.map((item) => {
                const message_entity = JSON.parse(item.message_entity)
                switch (item.status) {
                    case 0:
                        item.status_zn = '待发送'
                        break
                    case 999:
                        item.status_zn = '完成'
                        break
                    default:
                        break
                }
                item.type = message_entity.allow_endpoints[0] === 'wt' ? '模板消息' : '客服消息'
                item.tmpl_id = message_entity.tmpl_id
                item.params = JSON.stringify(message_entity.param)
                return item
            })
        },
        handler() {},
        createTemplate() {
            this.$refs['form'].validate(async (vaild) => {
                if (vaild) {
                    const params = {
                        message_entity: {
                            tmpl_id: this.form.tmpl_id,
                            param: this.form.param,
                            allow_endpoints: [this.form.allow_endpoints],
                        },
                        description: this.form.description,
                        priority: parseInt(this.form.priority, 10),
                    }
                    await request.messenger.post('broadcast_create', params)
                    this.$message.success('创建成功')
                    this.$refs['form'].resetFields()
                    this.getItemList()
                }
            })
        },
    },
}
</script>

<style scoped>
.head {
    text-align: right;
    margin-bottom: 30px;
}
.item {
    width: 200px;
}
.table-container {
    height: 400px;
}
.container-head {
    margin-bottom: 20px;
}
</style>
